export default __webpack_public_path__ + "static/media/hht1_song_07.9b292bd5.png";